import { inject, injectable } from "@launchtray/tsyringe-async";
import { Viewable } from "../../../../scene/viewable/Viewable";
import { PushResourcePackage } from "./resources/PushResourcePackage";
import { ICanvasScaler } from "../../../../canvas/ICanvasScaler";
import { PromiseCompletionSource } from "../../../../shared/async/PromiseCompletionSource";
import { CommonResourcesPackage } from "../../common/resources/CommonResourcesPackage";
import { PushPopupView } from "./view/PushPopupView";
import { IPushController } from "./controllers/IPushController";
import { TopPanel } from "../../game/components/toppanel/TopPanel";
import { IAnalyticProviderWrapper } from "../../../../analytics/IAnalyticProviderWrapper";
import { PushDialogData } from "../../game/flow/impl/dialogAction/PushDialogData";
import { ILogger } from "by/gamefactory/cityversetycoon/logger/ILogger";

@injectable()
export class PushPopupScene extends Viewable<void> {
    public constructor(
        pushResources: PushResourcePackage,
        commonResources: CommonResourcesPackage,
        @inject("IPushController") pushController: IPushController,
        @inject("IAnalyticProviderWrapper") analyticProvider: IAnalyticProviderWrapper,
        @inject("ICanvasScaler") canvasScaler: ICanvasScaler,
        @inject("PushDialogData") dialogData: PushDialogData,
        topPanel: TopPanel,
        @inject("ILogger") logger: ILogger
    ) {
        super();
        topPanel.interactiveChildren = false;
        const pcs = new PromiseCompletionSource<void>();
        this.view = new PushPopupView(
            pcs,
            canvasScaler,
            pushResources,
            commonResources,
            pushController,
            analyticProvider,
            topPanel,
            dialogData,
            logger
        );
        pcs.result.then(() => {
            topPanel.interactiveChildren = true;
            this.operationControls.complete();
            pushResources.destroy();
        }, (reason: any) => {
            topPanel.interactiveChildren = true;
            this.operationControls.error(reason);
        });
    }
}
